define('home/templates/profileCardFavorite',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " no-image";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.link : stack1), depth0))
    + "\"\nclass=\"discussion-image\"\ndata-link-name=\"image\"\ndata-link-out=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.signedLink : stack1), depth0))
    + "\"\ndata-thread-id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n\n<img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.src : stack1), depth0))
    + "\" alt=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.title : stack1), depth0))
    + "\">\n</a>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"card-discussion"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n<div class=\"card-aside\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.canShowThreadImage : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n<div class=\"card-body\">\n"
    + ((stack1 = container.invokePartial(partials.profileCardReason,depth0,{"name":"profileCardReason","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.threadTitle,depth0,{"name":"threadTitle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<div class=\"card-profile-activity\">\n"
    + ((stack1 = container.invokePartial(partials.userAvatar,(depth0 != null ? depth0.firstActor : depth0),{"name":"userAvatar","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + alias2(helpers.gettext.call(alias1,"%(userName)s recommended",{"name":"gettext","hash":{"userName":helpers.getPartial.call(alias1,"userName",(depth0 != null ? depth0.firstActor : depth0),{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + " <span class=\"bullet\">"
    + alias2(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
